export default class BasicService {
    constructor() {
        this._props = {};
        this._observers = [];
    }
    subscribe(observer) {
        this.observers.push(observer);
    }
    get props() {
        return this._props;
    }
    get observers() {
        return this._observers;
    }
    reset() {
        this._props = {};
        this._observers = [];
    }
    unsubscribe(observer) {
        const index = this.observers.indexOf(observer);
        this.observers.splice(index, 1);
    }
    notify(event) {
        this.observers.forEach((observer) => observer(event));
    }
}
//# sourceMappingURL=basicService.js.map